import React, { ChangeEvent, HTMLAttributes, useRef, useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import styled, { useTheme } from 'styled-components';

import {
	HelperText,
	InputBox,
	MoneyInputBox,
	InputBoxWrapper,
	InputWrapper,
	LabelText,
	MoneyIcon,
	helper_ani,
} from './style';
import { IInput } from './type';

const CoreInput = ({
	input_type = 'default',
	input_id,
	is_error = false,
	_placeholder,
	_disabled = false,
	label,
	helper,
	another_type,
	_onClick,
	_onKeyDown,
	_width = '100%',
	_onChange,
	_value,
	_ref,
	_margin,
	_autoComplete,
	_onBlur,
	...props
}: IInput & HTMLAttributes<HTMLInputElement>) => {
	// input DOM
	const inputbox_ref = useRef<HTMLInputElement>(null);
	const theme = useTheme();

	// 세 자리마다 콤마를 찍어 저장하는 state
	const [money_form, setMoneyForm] = useState('');

	// 세 자리 마다 콤마 추가
	const onChangeMoneyForm = (e: ChangeEvent<HTMLInputElement>) => {
		const {
			target: { value },
		} = e;
		const regex = /[^0-9]/g;
		const just_number = +value.replace(regex, '');
		if (just_number === 0) {
			setMoneyForm('');
		} else {
			const result = just_number.toLocaleString();
			setMoneyForm(result);
		}
	};

	// input창 클릭 시 커서가 입력한 제일 마지막 값으로 이동하는 커스텀 훅
	// useMoveLast(_ref ?? inputbox_ref);

	if (input_type === 'default')
		return (
			<InputWrapper
				_width={_width}
				_margin={_margin}
				onClick={(e) => e.stopPropagation()}
			>
				<LabelText input_id={input_id} is_label={label ? true : false}>
					{label}
				</LabelText>
				<InputBox
					type={another_type ?? 'text'}
					placeholder={_placeholder}
					disabled={_disabled}
					id={input_id}
					is_error={is_error}
					ref={_ref ?? (input_type === 'default' ? inputbox_ref : null)}
					value={_value}
					onChange={_onChange}
					onKeyDown={_onKeyDown}
					autoComplete={_autoComplete === 'off' ? 'off' : 'on'}
					onBlur={_onBlur}
					{...props}
				/>
				<AnimatePresence>
					{helper && helper !== '' && (
						<HelperText
							is_error={is_error ? 'true' : 'false'}
							variants={helper_ani}
							initial="init"
							animate="ani"
							exit="exit"
						>
							{helper}
						</HelperText>
					)}
				</AnimatePresence>
			</InputWrapper>
		);
	if (input_type === 'money')
		return (
			<InputWrapper _width={_width}>
				<LabelText input_id={input_id} is_label={label ? true : false}>
					{label}
				</LabelText>
				<InputBoxWrapper>
					<MoneyIcon>₩</MoneyIcon>
					<MoneyInputBox
						type={another_type ?? 'text'}
						placeholder={_placeholder}
						disabled={_disabled}
						id={input_id}
						is_error={is_error}
						ref={_ref ?? (input_type === 'money' ? inputbox_ref : null)}
						onChange={_onChange ? _onChange : onChangeMoneyForm}
						value={_value ? _value : money_form}
						onKeyDown={_onKeyDown}
					/>
				</InputBoxWrapper>
				<AnimatePresence>
					{helper && helper !== '' && (
						<HelperText
							is_error={is_error ? 'true' : 'false'}
							variants={helper_ani}
							initial="init"
							animate="ani"
							exit="exit"
						>
							{helper}
						</HelperText>
					)}
				</AnimatePresence>
			</InputWrapper>
		);

	return null;
};

export default CoreInput;

// props
// - input_type: default, button, money (피그마 참고)
// - input_id: 라벨과 연결지어주기 위한 것으로 고유한 id 입력
// - is_error: 에러 처리 상황 (boolean)
// - _placeholder: input에 입력이 없을 때의 값
// - label: 라벨에 들어갈 텍스트
// - helper: input 하단부에 오는 헬퍼 텍스트
// - !!_onClick!!: input_type이 button일 때에만 사용되는 것으로, 버튼 클릭 시의 동작을 내려준다.
